module.exports = __webpack_public_path__ + "img/11.d2884d26.png";